import { render, staticRenderFns } from "./SupplyPointDetail.vue?vue&type=template&id=0a4abc3c"
import script from "./SupplyPointDetail.vue?vue&type=script&lang=js"
export * from "./SupplyPointDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports